import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Initial state
const initialState = {
  data: null,
  error: false,
  loading: false,
  loaded: false,
};

// Slice
const ticketCloseSlice = createSlice({
  name: "ticketClose",
  initialState,
  reducers: {
    fetchTicketclose() {},
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const { fetchTicketclose, fetchDataSuccess, fetchDataFailure } =
  ticketCloseSlice.actions;

export default ticketCloseSlice.reducer;

//saga
function* fetchDataSaga(action) {
  try {
    const peerIp = yield select((state) => state.peerIp.ip);
    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      },
    });
    const response = yield call(apiService.post, apiUrl, data);
    yield put(fetchDataSuccess(response.data));
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* ticketCloseSaga() {
  yield takeLatest(fetchTicketclose.type, fetchDataSaga);
}
